<div class="auth-shell">
  <aside class="auth-brand">
    <svg class="auth-brand__pattern" width="100%" height="100%" aria-hidden="true">
      <defs>
        <pattern id="dot-grid" width="22" height="22" patternUnits="userSpaceOnUse">
          <circle cx="1.5" cy="1.5" r="1.5" fill="rgba(255,255,255,0.14)" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#dot-grid)" />
    </svg>

    <div class="auth-brand__content">
      <div class="auth-brand__mark">
        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path
            d="M12 2 4 5v6c0 5.2 3.4 9.9 8 11 4.6-1.1 8-5.8 8-11V5l-8-3Z"
            fill="rgba(255,255,255,0.16)"
            stroke="#fff"
            stroke-width="1.5"
          />
          <path
            d="m8.5 12 2.5 2.5 4.5-5"
            stroke="#fff"
            stroke-width="1.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>

      <h1>Outward Approval</h1>
      <p class="auth-brand__tagline">
        Review, approve and release flagged NIBSS outward transfers with a
        full audit trail at every step.
      </p>

      <ul class="auth-brand__points">
        <li>Dual visibility across ADMIN, OFFICER and AUDITOR roles</li>
        <li>Every decision is final and logged automatically</li>
        <li>Wallet liens are released the moment you decide</li>
      </ul>
    </div>

    <p class="auth-brand__footer">Transaction Management &middot; Approval Desk</p>
  </aside>

  <main class="auth-form-pane">
    <div class="auth-form-pane__inner">
      <header class="auth-form-header">
        <h2>{{ title() }}</h2>
        @if (subtitle()) {
          <p>{{ subtitle() }}</p>
        }
      </header>

      <ng-content />
    </div>
  </main>
</div>
